<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <div class="page-breadcrumb d-sm-flex align-items-center mb-4">
                <!-- <div class="breadcrumb-title pe-3"><span [translate]="'GREATER.PROGRAM'"> </span></div> -->
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0);" routerLink="/dashboard" ><i class="bx bx-home-alt"></i></a>
                            </li>
                            <!-- <li class="breadcrumb-item active" aria-current="page"><span [translate]="'GREATER.PROGRAM'"> </span></li> -->
                        </ol>
                    </nav>
                </div>
                <div class="ms-auto">
                    <div class="btn-group">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="card-title d-flex align-items-center">
                    <h5 class="mb-2" ><span [translate]="'GREATER.PROGRAM'"> </span></h5>
                </div>
                <hr>
                <div class="col-3 col-md-3 pb-3">
                    <label for="inputState" class="form-label"><span [translate]="'GREATER.SEARCH_PROGRAM'"> </span></label>
                    <input type="text" id="inputState" class="form-control" placeholder="{{ 'GREATER.SEARCH_PROGRAM' | translate }}" [(ngModel)]='searchKey' (keyup)="p=1;getDetail(p)">
                </div>
                <div class="col-3 col-md-3 pb-3">
                    <label for="inputState" class="form-label"><span [translate]="'GREATER.PRODUCT'"> </span></label>
                    <select id="inputState" class="form-select" [(ngModel)]='typeKey' (change)="p=1;getDetail(p)">
                        <option value="" selected hidden disabled><span [translate]="'GREATER.SELECT'"> </span></option>
                        <option value="1"><span [translate]="'GREATER.STANDARD'"> </span></option>
                        <option value="2"><span [translate]="'GREATER.NUTRITION'"> </span></option>
                        <option value="3"><span [translate]="'GREATER.HYBRID'"> </span></option>
                    </select>
                </div> 
                <div class="col-3 col-md-3 pb-3">
                    <label for="inputState" class="form-label"><span [translate]="'GREATER.STATUS'"> </span></label>
                    <select id="inputState" class="form-select" [(ngModel)]='statuskey' (change)="p=1;getDetail(p)">
                        <option value="" selected hidden disabled><span [translate]="'GREATER.SELECT'"> </span></option>
                        <option value="1"><span [translate]="'GREATER.PUBLISHED'"> </span></option>
                        <option value="2"><span [translate]="'GREATER.UNPUBLISHED'"> </span></option>
                        <option value="3"><span [translate]="'GREATER.DENIED'"> </span></option>
                        <option value="4"><span [translate]="'GREATER.REVIEW'"> </span></option>
                    </select>
                </div>
                <div class="col-3 col-md-3 pb-3">
                    <label for="inputState" class="form-label"><span [translate]="'GREATER.SEARCH_CREATED'"> </span></label>
                    <input type="text" id="inputState" class="form-control" placeholder="{{ 'GREATER.SEARCH_CREATED' | translate }}" [(ngModel)]='searchKey1' (keyup)="p=1;getDetail(p)">
                </div>
                <div class="col-3 col-md-3 pb-3 pt-4">
                    <button type="button" class="btn custom-btn brand-btn2 px-4" (click)="reset()"><span [translate]="'GREATER.RESET'"> </span></button>
                </div>

                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                        <th scope="col"><span [translate]="'GREATER.IMAGE'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.TITLE'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.PRODUCT'"> </span></th>
                                        <th scope="col">
                                            <span [translate]="'GREATER.PRICE'"> </span>
                                        </th>
                                        <th scope="col">
                                            <span [translate]="'GREATER.VIEWS'"> </span>
                                        </th>
                                        <th scope="col">
                                            <span [translate]="'GREATER.LIKES'"> </span>
                                        </th>                                        
                                                                                <th scope="col" class="d-flex"><span [translate]="'GREATER.DATE'"></span> 
                                           <span style="cursor: pointer;" class="ms-2"> <i class="bx bx-arrow-to-top" (click)="sortType='asc';p=1;getDetail(p)"></i> <i class="bx bx-arrow-to-bottom" (click)="sortType='desc';p=1;getDetail(p)"></i></span>  </th>

                                        <th scope="col"><span [translate]="'GREATER.CREATED_BY'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.STATUS'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.ACTIONS'"> </span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of dataListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                        <td><img [src]='item.program_image'  style="height:50px;width:50px"></td>
                                        <td>{{item.name}}</td>
                                        <td *ngIf="item.category_type==1"><span [translate]="'GREATER.STANDARD'"> </span></td>
                                        <td *ngIf="item.category_type==2"><span [translate]="'GREATER.NUTRITION'"> </span></td>
                                        <td *ngIf="item.category_type==3"><span [translate]="'GREATER.HYBRID'"> </span></td>
                                        <td>{{item.userCurrencySymbol }}{{item.price}}</td>
                                        <td>{{item.view}}</td>
                                        <td>{{item.likes}}</td>
                                        <td>{{service.convertDate(item.createdAt)}} </td>
                                        <td>{{item.created_by_name}} </td>
                                        <td>
                                            <div>
                                                <span class="badge bg-success" *ngIf="item.status =='Published' ">{{item.status}}</span>
                                                <span class="badge split-bg-warning" *ngIf="item.status == 'Unpublished'">{{item.status}}</span>
                                                <span class="badge bg-danger" *ngIf="item.status == 'Denied'">{{item.status}}</span>
                                                <span class="badge bg-info" *ngIf="item.status == 'Review'"><span [translate]="'GREATER.REVIEW'"> </span></span>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="btn-group" role="group" aria-label="Basic example">
                                                <button type="button" class="btn btn-warning text-center" title="Denied"   (click)="updateStatus(item._id,'Denied')"  *ngIf="item.status != 'Denied' && item.status == 'Review'"   >
                                                    <i class="bx bx-x"></i>
                                                </button>
                                                <!-- <button type="button" class="btn btn-success text-center"  title="Publish" (click)="updateStatus(item._id,'Published')"  *ngIf="item.status == 'Review' || item.status == 'Denied'">
                                                    <i class="bx bx-check"></i>
                                                </button> -->
                                                <button type="button" class="btn btn-info text-center" title="View" (click)="redirect(item,1)">
                                                    <i class="bx bx-show"></i>
                                                </button>
                                                <button type="button" class="btn btn-danger text-center" title="Delete"  (click)="redirect(item,2)">
                                                    <i class="bx bx-trash"></i>
                                                </button>
                                                <button type="button" class="btn btn-success text-center" title="In-Review" (click)="ReviewState(item._id)" *ngIf="item.status != 'Review' && item.status == 'Published'">
                                                    <i class="bx bx-repost"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail((p = $event))" class="text-center" *ngIf="dataListing.length > 0"></pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>